import script from "./ResumoGeralPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumoGeralPage.vue?vue&type=script&setup=true&lang=js"

import "./ResumoGeralPage.vue?vue&type=style&index=0&id=e7c2c7e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c2c7e0"]])

export default __exports__